import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaCrown } from "react-icons/fa6";

// MUI
import Tooltip from "@mui/material/Tooltip";

// Styles
import styles from "./subunit.module.scss";

const SubUnit = ({ subUnit, isLocked = false }) => {
  // Hooks
  const { t } = useTranslation();

  if (!subUnit) return null;
  const { title, familiarity } = subUnit;
  const isCompleted = familiarity === 100;

  const renderTooltip = () => {
    return (
      <div className="flex flex-col gap-2 p-2">
        <div className="flex flex-row items-center justify-between gap-2">
          <p className="text-gray-500 text-md">
            {t("masteryMap.subUnit.familiarity")}
          </p>

          <p className="text-gray-500 text-md">
            {`${familiarity}%`}
          </p>
        </div>

        <div className="flex flex-row items-center gap-2">
          <p className="text-white text-md">
            {title}
          </p>
        </div>
      </div>
    )
  }

  const renderProgress = () => {
    if (isLocked) return null;
    if (isCompleted) return <FaCrown className="text-white text-md" />
    return (
      <div className={styles.progress} style={{ height: `${familiarity}%` }} />
    )
  }

  const style = isCompleted && !isLocked ? 'bg-blue-600' : 'bg-white';
  const borderStyle = isLocked ? 'border-gray-400' : 'border-blue-500';
  return (
    <Tooltip
      title={renderTooltip()}
      classes={{
        tooltip: styles.tooltip
      }}
    >
      <div
        className={`${styles.subUnit} ${style} ${borderStyle}`}
        style={{ width: '24px', height: '24px' }}
      >
        {renderProgress()}
      </div>
    </Tooltip >
  );
};

export default SubUnit;
